import React from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import $ from 'jquery';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import * as offerActions from '../../../redux/newOffer';
import { chunk } from '../../../helpers';
import { media } from '../../../services/api';
import { OfferContainerImage } from '../../Common';
import '../Offer.css';

interface Props {
  returnImage: (item: Array<IGMedia>) => void;
  open: boolean;
  close: Function;
}

interface IGMedia {
  id: string;
  preview: string;
}
interface State {
  chosen: Array<IGMedia>;
  last_id: '';
  data: Array<IGMedia>;
  noMore: boolean;
}

class InstagramImport extends React.Component<Props, State> {
  state: State = { chosen: [], data: [], last_id: '', noMore: false };

  async componentWillUpdate(nextProps: Props, nextState: State, snapshot) {
    if (this.props.open === false && nextProps.open === true) {
      if (!this.state.data.length) {
        const result: any = await media.get();
        const data: Array<IGMedia> = result.data.map((item) => ({
          preview: item.thumbnail,
          file: item.full_size,
        }));
        this.setState({
          data,
          last_id: result.data[result.data.length - 1].id,
        });
      }
      const close = () => {
        this.props.close();
      };
      $('#instagramImportModal').on('hide.bs.modal', close).modal('show');
    }
  }

  chooseImage(item) {
    if (!this.state.chosen.map((x) => x.preview === item.preview).some((x) => !!x))
      this.setState({ chosen: [...this.state.chosen, item] });
    else this.setState({ chosen: this.state.chosen.filter((x) => x.preview !== item.preview) });
  }

  loadMore() {
    media.get({ last_id: this.state.last_id }).then((result: any) => {
      const last_id = result.data[result.data.length - 1].id;
      if (last_id === this.state.last_id) {
        this.setState({ noMore: true });
        return;
      }
      const data = result.data.map((item) => {
        return { preview: item.thumbnail, file: item.full_size, id: item.id };
      });
      this.setState({
        data: [...this.state.data, ...data],
        last_id: result.data[result.data.length - 1].id,
      });
    });
  }

  saveImage() {
    $('#instagramImportModal').modal('hide');
    this.setState({ chosen: [] });
    this.props.returnImage(this.state.chosen);
  }

  isChosen(item) {
    return this.state.chosen.some((x) => x.preview === item.preview);
  }

  render() {
    return (
      <div className="modal fade" id="instagramImportModal" role="dialog">
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal">
                &times;
              </button>
            </div>
            <div className="modal-body">
              <div style={{ height: '300px', overflowY: 'scroll', overflowX: 'hidden' }}>
                <InfiniteScroll
                  pageStart={0}
                  loadMore={() => this.loadMore()}
                  hasMore={!this.state.noMore}
                  useWindow={false}
                >
                  {chunk(this.state.data, 3).map((items) => (
                    <div className="row" key={items.reduce((a, i) => i.id + a, '')}>
                      {items.map((item) => (
                        <div className="col-md-4" key={item.id}>
                          <div style={{ position: 'relative' }}>
                            <OfferContainerImage
                              src={item.preview}
                              onClick={() => this.chooseImage(item)}
                            />
                            {this.isChosen(item) ? (
                              <div className="download-checkmark">✓</div>
                            ) : null}
                          </div>
                        </div>
                      ))}
                    </div>
                  ))}
                </InfiniteScroll>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-info"
                onClick={() => this.saveImage()}
                disabled={this.state.chosen.length === 0}
              >
                Select images
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    businessId: state.business.business_id,
    offer: state.offer,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    offerActions: bindActionCreators(offerActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(InstagramImport);
